import Types from './types';

export const fetchAllReports = () => ({
    type: Types.FETCH_ALL_REPORTS,
});

export const setLoader = () => ({
    type: Types.SET_LOADER,
});

export const createReport = (data) => ({
    payload: data,
    type: Types.CREATE_REPORT,
});

export const fetchReport = (id) => ({
    payload: id,
    type: Types.FETCH_REPORT,
});

export const updateReportName = (data) => ({
    payload: data,
    type: Types.UPDATE_REPORT_NAME,
});

export const deleteReport = (data) => ({
    payload: data,
    type: Types.DELETE_REPORT,
});

export const addSegment = (segmentsReportId, data) => ({
    payload: {
        data,
        segmentsReportId,
    },
    type: Types.ADD_SEGMENT,
});

export const deleteSegment = (data) => ({
    payload: data,
    type: Types.DELETE_SEGMENT,
});

export const updateSegment = (data) => ({
    payload: data,
    type: Types.UPDATE_SEGMENT,
});

export const moveProductToSegment = (data) => ({
    payload: data,
    type: Types.MOVE_PRODUCT_TO_SEGMENT,
});

export const deleteProduct = (data) => ({
    payload: data,
    type: Types.DELETE_PRODUCT,
});

export const selectProducts = (data) => ({
    payload: data,
    type: Types.SELECT_PRODUCT_FOR_SEGMENT,
});

export const unselectProducts = (data) => ({
    payload: data,
    type: Types.UNSELECT_PRODUCT_FOR_SEGMENT,
});

export const updateReport = (data) => ({
    payload: data,
    type: Types.UPDATE_REPORT,
});

export const updateReportList = (data) => ({
    payload: data,
    type: Types.UPDATE_REPORT_LIST,
});
export const addProductsToSegment = (data) => ({
    payload: data,
    type: Types.ADD_PRODUCTS_TO_SEGMENT,
});
